
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medical_institution/[id]/booking",
      function () {
        return require("private-next-pages/medical_institution/[id]/booking/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medical_institution/[id]/booking"])
      });
    }
  